import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ProjetoCulturalService from '../../../../services/projetoCultural-auth';



const Projeto = () => {
    const [patrocinador, setPatrocinador] = useState("");
    const [valor, setValor] = useState("");
    const [beneficiario, setBeneficiario] = useState("");
    const [dataCap, setDataCap] = useState("");
    const [andamento, setAndamento] = useState("");
    const [prazo, setPrazo] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const local = await ProjetoCulturalService.cadastro({
                patrocinador: patrocinador,
                valor: valor,
                beneficiario: beneficiario,
                dataCap: dataCap,
                andamento: andamento,
                prazo: prazo
            })
            if (local.data["_id"]) {
                alert("Projeto Cultural cadastrado com sucesso!")
                setSucesso(true);
            }
            else {
                alert(local.data["error"]);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const ponto = (campo) => {
        return campo.replace(/,/g, ".");
    }

    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setPatrocinador("");
        setValor("");
        setBeneficiario("");
        setAndamento("");
        setPrazo("");
        setDataCap("");
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="patrocinador">
                                <FloatingLabel
                                    label="Patrocinador/Doador"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="patrocinador"
                                        value={patrocinador}
                                        onChange={e => setPatrocinador(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="beneficiario">
                                <FloatingLabel
                                    label="Beneficiario"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="beneficiario"
                                        value={beneficiario}
                                        onChange={e => setBeneficiario(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Valor Captado">
                                <FloatingLabel
                                    label="Valor Captado"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="valor"
                                        value={valor}
                                        onChange={e => setValor(ponto(e.target.value))} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Data de Captação">
                                <FloatingLabel
                                    label="Data de Captação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataCap"
                                        value={dataCap}
                                        onChange={e => setDataCap(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Andamento do Projeto">
                                <FloatingLabel
                                    label="Andamento do Projeto"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Andamento do Projeto"
                                        name="andamento"
                                        onChange={e => setAndamento(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Em Andamento">Em Andamento</option>
                                        <option value="Recursos Captados">Recursos Captados</option>
                                        <option value="Concluído">Concluído</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Prazo Final">
                                <FloatingLabel
                                    label="Prazo Final"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="prazo"
                                        value={prazo}
                                        onChange={e => setPrazo(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        

                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/renuncias/projetocultural'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Projeto Cultural cadastrado com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outro
                </Button>
                <br /><br />
                <Link to={'/restrito/renuncias/projetocultural/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Projetos Culturais
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/renuncias/projetocultural'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Projeto;